import { Icon } from '@iconify/react';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/Domain/components/Shared/AlertDialog/AlertDialog';
import { Button } from '@/Domain/components/Shared/Button/Button';
import { Separator } from '@/Domain/components/Shared/Separator/Separator';
import { useSubscription } from '@/Domain/components/SubscriptionProvider';
import { UpgradePlanButton } from '@/Domain/components/UpgradePlanButton/UpgradePlanButton';
import { PostHogEventEnum } from '@/Domain/enum/PostHogEvent.enum';
import { usePostHogAnalytics } from '@/Domain/hooks/App/usePostHog/usePostHogAnalytics.hook';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

export const ArticleLimitModal = () => {
  const { isOpen, closeModal } = useModalStore();
  const { t } = useTranslation('knowledge_base');
  const { capture } = usePostHogAnalytics();
  const { getConfig } = useSubscription();
  const open = isOpen(MODAL_NAMES.ARTICLE_LIMIT_MODAL);

  // Dedupe ref so socket-driven SubscriptionProvider re-renders (which
  // re-create `getConfig`) don't refire the event mid-modal.
  const wasOpen = useRef(false);
  useEffect(() => {
    if (open && !wasOpen.current) {
      capture(PostHogEventEnum.KbLimitModalOpened, {
        articles_used: getConfig('articles_used') as number | undefined,
        articles_limit: getConfig('articles_limit') as number | null | undefined,
      });
    }
    wasOpen.current = open;
  }, [open, capture, getConfig]);

  return (
    <AlertDialog open={open} onOpenChange={(o) => !o && closeModal()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>
            <Icon
              icon="mingcute:alert-fill"
              className="bg-warning-muted rounded-full text-warning p-1.5 box-content"
            />
            {t('articles.upgrade.title')}
          </AlertDialogTitle>
          <AlertDialogDescription>{t('articles.upgrade.description')}</AlertDialogDescription>
        </AlertDialogHeader>
        <Separator />
        <AlertDialogFooter>
          <Button variant="secondary" size="sm" onClick={closeModal}>
            {t('button.cancel')}
          </Button>
          <UpgradePlanButton size="sm" source="kb_limit_modal" />
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
